import crypto from 'crypto-js';

export const hashObjectValues = <T>(data: T, excludeKeys: (keyof T)[]): T =>
    Object.keys(data || {}).reduce((acc: T, key) => {
        const typedKey: keyof T = key as keyof T;

        if (!excludeKeys.includes(typedKey)) {
            acc[typedKey] = hash(data[typedKey]);
            return acc;
        }

        acc[typedKey] = data[typedKey];
        return acc;
    }, {} as T);

export const hash = <T>(data: T): T => crypto.SHA256(String(data)).toString(crypto.enc.Hex) as unknown as T;
